import IconComponent from 'components/common/IconComponent';
import React from 'react';
import { ActionButtonStyled } from 'routes/Appointments/styled';
import { IAppointment } from 'types/appointments';
import { GeneralFunction } from 'types/common';
import { hexToRgb } from 'utils';

const ContactNLabelButtons: React.FC<{
  contactClick?: GeneralFunction;
  shippingLabelClick?: GeneralFunction;
  shippingLabelLoading?: boolean;
  containerClassName?: string;
  unreadMessageCount?: number;
  appointment: IAppointment;
}> = ({
  contactClick,
  shippingLabelClick,
  containerClassName = '',
  appointment,
  unreadMessageCount,
  shippingLabelLoading,
}) => (
  <div className={containerClassName}>
    {!!contactClick && (
      <ActionButtonStyled
        className='gx-p-0'
        onClick={(e) => {
          e.stopPropagation();
          contactClick?.(appointment);
        }}
        buttonType='text'
        color={hexToRgb('#038fde', 0.7)}
        colorOnHover='#038fde'>
        <div className='gx-d-flex gx-align-items-center'>
          <IconComponent
            className='gx-mr-1'
            style={{ transform: 'rotateY(180deg)' }}
            name='chat'
            color='038fde'
            size={13}
          />
          <span>
            Message Client
            {unreadMessageCount === 0 || !unreadMessageCount ? '' : ` (${unreadMessageCount})`}
          </span>
        </div>
      </ActionButtonStyled>
    )}
    {shippingLabelClick && (
      <ActionButtonStyled
        isLoading={!!shippingLabelLoading}
        spinnerColor='038fde'
        className='gx-p-0'
        onClick={(e) => {
          e.stopPropagation();
          shippingLabelClick?.(appointment);
        }}
        buttonType='text'
        color={hexToRgb('#038fde', 0.7)}
        colorOnHover='#038fde'>
        <div className='gx-d-flex gx-align-items-center'>
          <IconComponent
            className='gx-mr-1'
            style={{ transform: 'rotateY(180deg)' }}
            name='ticket-new'
            color='038fde'
            size={13}
          />
          <span>Shipping Label</span>
        </div>
      </ActionButtonStyled>
    )}
  </div>
);

export default ContactNLabelButtons;
